/** API route map: URLS.Controller.JobRequest */
export const JobRequest = {
      Name: 'JobRequest/',
      AddJob: 'add-job-request',
      UpdateJob: 'update-job-request',
      GetAll: 'job-requests',
      Delete: 'delete',
      Tiles: 'tiles',
      UpdateStatus: 'update-status',
      UpdateApprovedStatus: 'update-approved-status',
      BillingStatus: 'billing-status',
      GetAllJobRequestsBoardView: 'job-requests-board-view',
      GetJobRequestSkills: 'get-job-request-skills',
      GetJobRequestById: 'get-job-request-by-id',
};
